import { gql } from '@apollo/client';
import inflection from 'inflection';
import _ from 'lodash';
import React from 'react';
import type { ImportGithubWikiConfirmation_ResultsFragment } from '../../graphql/generated/graphqlTypes';
import { Link } from '../../utils/router/v3Bridge';
import postPath from '../../utils/url/postPath';
import styles from './GithubWikiImportConfirmation.module.scss';

const RESULTS_FRAGMENT = gql`
  fragment ImportGithubWikiConfirmation_results on GithubWikiImportResult {
    repo {
      owner
      name
    }
    errorMessage
    imported {
      id
      publishedAt
      title
    }
  }
`;

interface GithubWikiImportConfirmationProps {
  results: ImportGithubWikiConfirmation_ResultsFragment[];
}

const ImportGithubWikiConfirmation = ({
  results,
}: GithubWikiImportConfirmationProps) => {
  const total = _.sumBy(results, 'imported.length') || 0;

  return (
    <>
      All done! We imported {total} {inflection.inflect('post', total)} from{' '}
      {results.length} {inflection.inflect('repo', results.length)} for you.
      {results.map((result) => {
        const { repo, errorMessage, imported } = result;

        return (
          !!repo && (
            <div key={`${repo.name}/${repo.owner}`} className={styles.content}>
              <h4>
                {repo.owner}/{repo.name}
              </h4>
              {errorMessage ||
                (!!imported && (
                  <>
                    {imported.length}{' '}
                    {inflection.inflect('post', imported.length)} imported.
                    <ul>
                      {_.compact(imported).map((post) => (
                        <li key={post.id}>
                          <Link to={postPath(post)} target="_blank">
                            {post.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ))}
            </div>
          )
        );
      })}
    </>
  );
};

ImportGithubWikiConfirmation.fragments = { results: RESULTS_FRAGMENT };

export default ImportGithubWikiConfirmation;
